var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInlineSofwerxLinear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sofwerx_linear",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 278.7 88.6",
    style: {
      enableBackground: "new 0 0 278.7 88.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SOFWERX Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.9,51.5c0.1,3,1.5,4.7,4.4,4.9v5.9c-8-0.3-11.9-3.9-11.9-10.9H19.9z M37.8,53.6c0,5.6-3.9,8.5-11.6,8.7 v-5.9c2.6-0.2,3.9-1.2,3.9-2.8c-0.2-1.1-0.9-2.1-2-3c-2-1.5-3.8-2.9-5.6-4.2c-1.7-1.3-3.4-2.5-5.1-3.6c-2.3-1.8-3.8-4.3-4.3-7.2 c0-5.7,3.7-8.7,11.2-8.9v5.8c-1.3,0.1-2.2,0.5-2.6,1c-0.5,0.5-0.7,1.3-0.7,2.3c0,1,0.4,1.7,1.2,2.2c0.5,0.3,1.2,0.7,1.9,1.2 c0.7,0.5,1.5,1,2.4,1.6c0.8,0.6,1.6,1.1,2.4,1.7c0.8,0.6,1.5,1.1,2.2,1.6c0.6,0.5,1.2,0.8,1.6,1.1c0.4,0.3,0.6,0.4,0.6,0.4 C36.3,47.9,37.8,50.5,37.8,53.6z M29.6,36.7c0-2.4-1.1-3.8-3.4-4.1v-5.8c7.6,0.3,11.3,3.6,11.3,9.9H29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.1,36.2c0-6.1,3.8-9.3,11.4-9.6v5.6c-2.2,0.3-3.3,1.5-3.3,3.6v17.3c0,2.2,1.1,3.4,3.3,3.7v5.5 c-7.6-0.3-11.4-3.8-11.4-10.5V36.2z M66.3,35.8c0-2.2-1.1-3.4-3.4-3.6v-5.6c7.8,0.1,11.6,3.3,11.6,9.8V52c0,6.7-3.9,10.1-11.6,10.3 v-5.5c2.3-0.2,3.4-1.4,3.4-3.7V35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.2,61.6h-7.9V27.4h7.9V61.6z M96.4,27.4h10.3v5.8H96.4V27.4z M96.4,40.9h9.7v5.7h-9.7V40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.1,42l3.9-14.7h7.4L149.8,56L146.1,42z M124.1,27.4h-7.5l9.1,34.3h5.2l0,0l0,0l1.1-4.2l-2-7.5L124.1,27.4z  M148.8,59.7l-0.5,1.9h-5.2l0,0l-0.1,0l-6-22.4l-4.1,15.4L129.5,42l3.9-14.6h3.6h3.6l8.4,31.5L148.8,59.7L148.8,59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.3,61.6h-7.9V27.4h7.9V61.6z M178.5,27.4h10.3v5.8h-10.3V27.4z M178.5,40.9h9.7v5.7h-9.7V40.9z  M188.8,61.6h-10.3v-5.9h10.3V61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.8,61.6H203V27.4h7.8V61.6z M215,41.2c1.2,0,2.2-0.3,2.8-1c0.6-0.7,0.9-1.6,0.9-2.9c0-1.5-0.3-2.6-0.9-3.2 c-0.6-0.7-1.5-1-2.8-1h-2.7v-5.8h2.5c8,0,11.9,3,11.9,9.1c0,2.2-0.4,4-1.1,5.3c-0.7,1.3-1.9,2-3.5,2.4c3,0.8,4.5,3.1,4.5,7v7.5 c0,0.7,0,1.3,0.1,1.8c0.1,0.5,0.2,0.9,0.4,1.3h-8c-0.4-0.5-0.6-1.4-0.6-2.5v-7.7c0-2.9-1.2-4.4-3.6-4.4h-2.7v-5.7H215z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.9,52l-4.3,9.6h-8.3l8.9-16.1L250.9,52z M246.7,27.4l19.7,34.3h-8.5l-19.6-34.3H246.7z M265.6,27.4 L257,42.4l-3.6-6.5l3.9-8.5H265.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276,21.5h-104l-1.2-1.3l-3.6,1.3l-4.4,0l0,0c0,0-1.4-1.8-3.1-3l2-7.3l0.1-0.2c0,0,0,0,0,0l0-0.1l0,0 c-0.4-0.3-5.2-3.5-7.7-4.3l-4.8,5.7c0,0-1.4-1-5.7-1.6c-0.7-2.5-1.4-6-2-8.5c-1.4-0.3-9,0-9,0c0,0,0,0,0,0 c-0.7,2.6-1.4,6.2-2.1,8.8c-2.6,0.2-5.5,1.5-5.5,1.5s-4.2-5.5-4.9-5.8c-0.7-0.3-7.7,4.3-7.7,4.3l2,7.6c-0.9,0.8-2.5,2.3-3.2,3.1 l-0.1,0l-4.1,0l-4.1-1.3l-1,1.3H4.4l0,3.4H276L276,21.5z M136.9,18c4.8,0,9.2,1.3,13.1,3.5l-26.2,0C127.6,19.3,132.1,18,136.9,18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276,67.4l0-3.4H4.4l0,3.4l97.5,0l1,1.3l3.9-1.3h4.4c1,1.1,3.7,3.5,3.7,3.5l-2.6,7.1c0,0,6.9,4.6,7.7,4.3 c0.7-0.3,4.9-5.8,4.9-5.8s3,1.3,5.5,1.5c0.7,2.6,1.4,5.2,2.1,7.8c0,0,7.4,0.3,8.9,0c0,0,0.1,0,0.1,0c0.7-2.5,1.3-5,2-7.6 c4.3-0.7,5.7-1.6,5.7-1.6l4.8,5.7c2.7-0.9,7.8-4.4,7.8-4.4l-2.7-7c2-1.1,3.8-3.5,3.8-3.5h4.4l3.6,1.3l1.2-1.3L276,67.4z  M136.8,71.9c-5.4,0-10.5-1.7-14.7-4.5h29.4C147.3,70.2,142.3,71.9,136.8,71.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInlineSofwerxLinear);
export default __webpack_public_path__ + "static/media/inline-sofwerx_linear.4ad3ae0922b941a9cc5de9754c580f2f.svg";
export { ForwardRef as ReactComponent };